import { ProductType } from '@sso/shared/constants';
import type { BoxProps } from '@sso/shared/hocs';
import { Text } from '@sso/shared/core';

import { Container, Cards } from './ProductSelect.styles';
import ProductSelectCard from './ProductSelectCard';

type ProductSelectProps = BoxProps & {
    onSelect: (product: ProductType) => void;
    withFeatures?: boolean;
};

function ProductSelect({ withFeatures, onSelect, ...props }: ProductSelectProps) {
    return (
        <Container {...props}>
            <Text color="neutral.section" weight="semiBold" size="displayMd" wide mb={8} as="h1">
                Select your product to continue
            </Text>
            <Text color="neutral.subtitle" wide mb={32} as="p">
                You can switch products at any time.
            </Text>
            <Cards>
                <ProductSelectCard
                    title="Host your own VPN server."
                    id="as-product-select-card"
                    withFeatures={withFeatures}
                    product={ProductType.As}
                    onSelect={onSelect}
                />
                <ProductSelectCard
                    title="Connect to our managed business VPN, ZTNA, and SSE service."
                    id="cloud-product-select-card"
                    withFeatures={withFeatures}
                    product={ProductType.Cloud}
                    onSelect={onSelect}
                />
            </Cards>
        </Container>
    );
}

export default ProductSelect;
